import React from "react";
export interface OnboardingProps {
    onGetDinnerTable: (tableNumber: number)=> void
}

export enum OnSiteOrToTakeAwayEnum {
    onTheSite = "Sur place",
    onTheTakeAway = "À emporter"
}